import { useMemo, useState } from 'react';
import { usePaginationParams } from '@common-fe/common-fe';

import { ALL_OPTION } from '@/common/constants';
import { Option, OptionKey } from '@/common/types';
import { stateAllToggling } from '@/utils/handlers/dropdownStateAllToggling';

import { SearchParams } from '../../EligibleServices.types';

const SORT_OPTIONS: Option[] = [
  {
    key: 'ASC',
    value: 'A-Z',
  },
  {
    key: 'DESC',
    value: 'Z-A',
  },

];

export default () => {
  const [categories, setCategories] = useState<OptionKey[]>([ALL_OPTION.value]);
  const [serviceType, setServiceType] = useState<OptionKey[]>([ALL_OPTION.value]);
  const categoriesParamsValues = useMemo(() => stateAllToggling(categories), [categories]);
  const serviceTypeParamsValues = useMemo(() => stateAllToggling(serviceType), [serviceType]);
  const [sortParams, setSortParams] = useState<OptionKey | null>(SORT_OPTIONS[0].key);
  const {
    searchString, setSearchString, currentSearch, 
  } = usePaginationParams();
  const params = useMemo<SearchParams>(() => ({
    name: currentSearch,
    sort: sortParams ? `name,${sortParams}` : '',
    categories: categoriesParamsValues as string[],
    types: serviceTypeParamsValues as string[],
  }), [currentSearch, sortParams, categoriesParamsValues, serviceTypeParamsValues]);

  return {
    setSearchString,
    searchString,
    currentSearch,
    sortOptions: SORT_OPTIONS,
    params,
    setSortParams,
    sortParams,
    serviceTypeParamsValues,
    setServiceType,
    categoriesParamsValues,
    setCategories,
  };
};
